<template lang="pug">
b-modal#editCampaign(
  ref="editCampaign"
  :title="$t('ui.combine.edit_campaign')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.campaign_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="campaign_id"
        required
        type="text"
        :dirty="$v.campaign_id.$dirty"
        :error="$v.campaign_id.$error"
        v-model.trim.lazy="$v.campaign_id.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    b-form-group(:label="$t('ui.campaign_name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="campaign_name"
        required
        type="text"
        :dirty="$v.campaign_name.$dirty"
        :error="$v.campaign_name.$error"
        v-model.trim.lazy="$v.campaign_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.campaign_name" :name="$t('ui.campaign_name')")
    b-form-group(:label="$t('ui.rollover')").mb-0
      DebounceInput(
        size="sm"
        ref="rollover"
        type="text"
        :dirty="$v.rollover.$dirty"
        :error="$v.rollover.$error"
        v-model.trim.lazy="$v.rollover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
    b-form-group(:label="$t('ui.criteria')").mb-0
      VipCriteriaList(
        ref="criteria"
        size="sm"
        required
        type="array"
        :dirty="$v.criteria.$dirty"
        :error="$v.criteria.$error"
        v-model.trim.lazy="$v.criteria.$model"
        :disabled="loading"
        :hideOpt="hideOpt"
      )
      ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
    b-form-group(:label="$t('ui.is_addon')").mb-2
      div.d-flex
        label.custom-switch
          input.custom-switch-input(
            type="checkbox"
            required
            :dirty="$v.is_addon.$dirty"
            :error="$v.is_addon.$error"
            v-model.trim.lazy="$v.is_addon.$model"
            :disabled="loading"
          )
          span.custom-switch-indicator
    template(v-if="!is_addon")
      b-form-group(:label="$t('ui.withhold_bonus')").mb-2
        div.d-flex
          label.custom-switch
            input.custom-switch-input(
              type="checkbox"
              required
              :dirty="$v.withhold_bonus.$dirty"
              :error="$v.withhold_bonus.$error"
              v-model.trim.lazy="$v.withhold_bonus.$model"
              :disabled="loading"
            )
            span.custom-switch-indicator
      b-form-group(:label="$t('ui.withhold_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="withhold_amount"
          required
          type="text"
          :dirty="$v.withhold_amount.$dirty"
          :error="$v.withhold_amount.$error"
          v-model.trim.lazy="$v.withhold_amount.$model"
          :disabled="loading || withhold_bonus"
        )
        ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
      b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="max_withdraw_amount"
          required
          type="text"
          :dirty="$v.max_withdraw_amount.$dirty"
          :error="$v.max_withdraw_amount.$error"
          v-model.trim.lazy="$v.max_withdraw_amount.$model"
          :disabled="loading || max_withdraw_multiple > 0"
        )
        ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
      b-form-group(:label="$t('ui.max_withdraw_multiple')").mb-0
        DebounceInput(
          size="sm"
          ref="max_withdraw_multiple"
          required
          type="text"
          :dirty="$v.max_withdraw_multiple.$dirty"
          :error="$v.max_withdraw_multiple.$error"
          v-model.trim.lazy="$v.max_withdraw_multiple.$model"
          :disabled="loading || max_withdraw_amount > 0"
        )
        ValidateResult(:value="$v.max_withdraw_multiple" :name="$t('ui.max_withdraw_multiple')")
      b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 50vh;").mb-0
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          tr
            th.text-center.col-checkbox(colspan=2)
              .d-flex
                .custom-checkbox.custom-control
                  input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                  label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                template(v-for="(cat, index) in providerCatList")
                  .custom-checkbox.custom-control
                    input.custom-control-input(
                      type="checkbox"
                      :id="'all-' + cat.toLowerCase()"
                      v-model="allSelected[index + 1]"
                      @change="selectAll(index + 1,$event)"
                      :disabled="loading"
                    )
                    label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
          tr(v-for='(p, index) in pList')
            td.text-center.col-checkbox(width="5%")
              .custom-checkbox.custom-control
                input.custom-control-input(:id="'all-' + index" type='checkbox' v-model="provider_list" :value='p.value' :disabled="loading")
                label.custom-control-label(:for="'all-' + index") &nbsp;
            td {{ p.text }}
        ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      operator_id: "",
      campaign_id: "",
      campaign_name: "",
      rollover: "",
      criteria: "",
      is_addon: true,
      withhold_bonus: false,
      withhold_amount: 0,
      max_withdraw_amount: 0,
      max_withdraw_multiple: 0,
      provider_list: [],
      providerList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      hideOpt: ['DEPOSIT'],
      allSelected: {},
      pList: [],
      providerCatList: [],
      prefixMap: {}
    };
  },
  computed: {
  },
  validations: {
    operator_id: {
      required
    },
    campaign_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    campaign_name: {
      required,
      maxLength: maxLength(100)
    },
    rollover: {
      integer,
      required
    },
    criteria: {
      required
    },
    is_addon: {
      required
    },
    withhold_bonus: {
      required: requiredIf(function () {
        return this.is_addon == false;
      })
    },
    withhold_amount: {
      decimal,
      required: requiredIf(function () {
        return this.is_addon == false;
      })
    },
    max_withdraw_amount: {
      decimal,
      required: requiredIf(function () {
        return this.is_addon == false;
      })
    },
    max_withdraw_multiple: {
      integer,
      required: requiredIf(function () {
        return this.is_addon == false;
      })
    },
    provider_list: {
      atLeastOneProvider,
      minLength: minLength(1),
      required
    },
  },
  watch : {
    is_addon(newValue, oldValue) {
      if(newValue) {
        this.provider_list = [];
        let list = this.providerList;

        for(var i = 0; i < list.length; i++) {
          this.provider_list.push(list[i].value);
        }
      } else {
        // this.provider_list = []
        if(this.withhold_bonus == null) {
          this.withhold_bonus = false
        }
      }
    },
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.pList.length && this.pList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.pList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    },
    withhold_bonus(newVal) {
      if(newVal)
        this.withhold_amount = 0
    },
    max_withdraw_amount(newVal) {
      if(newVal)
        this.max_withdraw_multiple = 0
    },
    max_withdraw_multiple(newVal) {
      if(newVal)
        this.max_withdraw_amount = 0
    }
  },
  methods: {
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.pList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.pList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false, category: list[i].category});
      }
      this.pList = result;

      this.initialProviderCheckbox();
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operator_id,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                this.setCategory();
                this.getPList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    initialProviderCheckbox() {
      if (this.item.provider_list != null) {
        var arr = this.item.provider_list.split(',');
        // Get all valid provider codes from pList
        const validProviderCodes = this.pList.map(p => p.value);

        for(var i = 0; i < arr.length; i++) {
          // Only add provider codes that exist in the current pList
          if (validProviderCodes.includes(arr[i])) {
            this.provider_list.push(arr[i]);
          }
        }
      }
      else {
        this.allSelected[0] = true;
        var arr = this.pList;
        for(var i = 0; i < arr.length; i++) {
          this.provider_list.push(arr[i].value);
        }
      }
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.withhold_bonus && parseFloat(this.withhold_amount) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.withtholdBonusAndAmountGreaterThanZero"), "error");
          return;
        }

        if (parseFloat(this.max_withdraw_amount) > 0 && parseFloat(this.max_withdraw_multiple) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.maxWithdrawMultipleAndAmountGreaterThanZero"), "error");
          return;
        }

        let url = config.campaignEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operator_id,
          campaign_id: this.campaign_id,
          campaign_name: this.campaign_name,
          rollover: this.rollover,
          criteria: this.criteria,
          is_addon: this.is_addon,
          withhold_bonus: this.withhold_bonus,
          withhold_amount: this.withhold_amount,
          max_withdraw_amount: this.max_withdraw_amount,
          max_withdraw_multiple: this.max_withdraw_multiple,
          audit_by: this.$store.getters.loginId
        };

        if (this.provider_list.length != this.pList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editCampaign.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_campaign", this.feedback.status);
                  this.$refs.editCampaign.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.providerList = [];
      this.provider_list = [];
      this.pList = [];
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)
      this.operator_id = this.item.account_id;
      this.campaign_id = this.item.campaign_id;
      this.campaign_name = this.item.campaign_name;
      this.rollover = this.item.rollover;
      this.criteria = this.item.criteria;
      this.is_addon = this.item.is_addon;
      this.withhold_bonus = this.item.withhold_bonus;
      this.withhold_amount = this.item.withhold_amount;
      this.max_withdraw_amount = this.item.max_withdraw_amount;
      this.max_withdraw_multiple = this.item.max_withdraw_multiple;
      // this.provider_list = this.item.provider_list != null ? this.item.provider_list.toUpperCase().split(',') : [];
      this.getProviderList();
    }
  }
};
</script>
